import { useState } from 'react'

import { Trans, useTranslation } from 'react-i18next'

import { useMeeting } from '../../../hooks'
import { Button, Modal, Text } from '../../basics'

export function AgreementModal() {
  const { i18n } = useTranslation()
  const ja = i18n.getFixedT('ja', 'translation', 'components.AgreementModal')
  const en = i18n.getFixedT('en', 'translation', 'components.AgreementModal')
  const { selectDevice } = useMeeting()
  const [isModalOpen, setIsModalOpen] = useState(true)

  return (
    <Modal open={isModalOpen} onClose={() => {}} closable={false} size="large">
      <div>
        <Text size="lg2" align="center">
          <Trans
            i18nKey="components.AgreementModal.description"
            tOptions={{ lng: 'ja' }}
          />
        </Text>
        <Text size="lg2" align="center">
          <Trans
            i18nKey="components.AgreementModal.description"
            tOptions={{ lng: 'en' }}
          />
        </Text>
      </div>
      <div className="mt-8 flex justify-center">
        <Button
          onClick={async () => {
            try {
              await selectDevice()
            } finally {
              setIsModalOpen(false)
            }
          }}
          square
          size="l"
          fill
        >
          <div className="flex items-center justify-center gap-2">
            <Text size="lg2">{ja('agree')}</Text>
            <Text size="lg2">{en('agree')}</Text>
          </div>
        </Button>
      </div>
    </Modal>
  )
}
